<template>
  <el-drawer
    :append-to-body="true"
    :title="$t('home.advancedSearch')"
    :visible.sync="searchDrawer"
    direction="ltr"
    size="600px"
  >
    <el-form label-position="top" size="small">
      <el-row
        :gutter="10"
        justify="left"
        style="flex-wrap: wrap; padding: 0 20px; box-sizing: border-box"
        type="flex"
      >
        <el-col :span="12">
          <!-- 发件人州 -->
          <el-form-item :label="$t('newOrder.SenderState')">
            <el-select
              v-model="localParams.senderStateList"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in StateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 包裹类型 -->
          <el-form-item :label="$t('placeOrder.packageType')">
            <el-select v-model="localParams.orderPackageType" style="width: 100%">
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option :label="$t('placeOrder.zhifa')" :value="1" />
              <el-option :label="$t('orderCenterCont.hedan')" :value="2" />
              <el-option :label="$t('GlobalSetObj.big01')" :value="4" />
              <el-option :label="$t('orderCenterCont.other')" :value="3" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col v-if="searchProp.includes('lostType')" :span="12">
          <!-- 标签 -->
          <el-form-item :label="$t('navbar.tag')">
            <el-select
              v-model="localParams.lostType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              style="width: 100%"
            >
              <el-option :label="$t('GlobalSetObj.all')" :value="null" />
              <el-option
                v-for="item in lostTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <!-- 订单类型 -->
          <el-form-item :label="$t('collectionCenter.tipoTitle')" size="small">
            <el-select
              v-model="localParams.isReverse"
              :placeholder="$t('collectionCenter.pleaseChoose')"
              style="width: 100%"
            >
              <!-- 全部 -->
              <el-option :label="$t('collectionCenter.tudo')" :value="null" />
              <!-- 原单 -->
              <el-option :label="$t('collectionCenter.originalOrder')" :value="0" />
              <!-- 原单退回 -->
              <el-option :label="$t('collectionCenter.originalOrderReturned')" :value="2" />
              <!-- 新单退回 -->
              <el-option :label="$t('collectionCenter.newOrderReturned')" :value="1" />
              <!-- 原单退回D2D -->
              <el-option :label="$t('trajectory.originalOrderReturn_D2D')" value="" />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div class="drawer-footer">
      <el-button size="small" @click="handleReset">{{ $t('newOrder.reset') }}</el-button>
      <el-button size="small" type="primary" @click="handleSearch">{{ $t('newOrder.search') }}
      </el-button>
    </div>
  </el-drawer>
</template>

<script>
import cloneDeep from 'lodash-es/cloneDeep';

const DEFAULT_PARAMS = {
  senderStateList: [],
  orderPackageType: null,
  lostType: null,
  isReverse: null
};

export default {
  name: 'SearchCom',
  props: {
    searchProp: {
      type: Array,
      default: () => []
    },
    StateList: {
      type: Array,
      default: () => []
    },
    lostTypeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchDrawer: false,
      localParams: cloneDeep(DEFAULT_PARAMS)
    };
  },
  methods: {
    showDialog() {
      // 保留未提交的编辑条件：关闭再打开不自动清空，仅可通过"重置"手动清空
      this.searchDrawer = true;
    },
    handleSearch() {
      this.$emit('search', cloneDeep(this.localParams));
      this.searchDrawer = false;
    },
    handleReset() {
      this.localParams = cloneDeep(DEFAULT_PARAMS);
    },
    // 返回已选择的查询条件（供父组件搜索时同步）
    getLocalParams() {
      return cloneDeep(this.localParams);
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  box-sizing: border-box;
}
</style>
